export default (menuToOpen) => menuToOpen;
